module.exports = __webpack_public_path__ + "img/55b.e889292d.svg";